import aboutUsEn from './snippets/about-us-en';
import aboutUsRo from './snippets/about-us-ro';
import brandInfoEn from './snippets/brand-info-en';
import brandInfoRo from './snippets/brand-info-ro';
import cookieDeclarationEn from './snippets/cookie-declaration-en';
import cookieDeclarationRo from './snippets/cookie-declaration-ro';
import cookiePolicyEn from './snippets/cookie-policy-en';
import cookiePolicyRo from './snippets/cookie-policy-ro';
import cookieNotificationEn from './snippets/cookie-privacy-notification-en';
import cookieNotificationRo from './snippets/cookie-privacy-notification-ro';
import depositNetellerEn from './snippets/deposit-neteller-en';
import depositNetellerRo from './snippets/deposit-neteller-ro';
import depositSkrillEn from './snippets/deposit-skrill-en';
import depositSkrillRo from './snippets/deposit-skrill-ro';
import footerHelpEn from './snippets/footer-help-en';
import footerHelpRo from './snippets/footer-help-ro';
import footerRightNavEn from './snippets/footer-rightNav-en';
import footerRightNavRo from './snippets/footer-rightNav-ro';
import footerSocialsEn from './snippets/footer-social-en';
import footerSocialsRo from './snippets/footer-social-ro';
import gamesInfoEn from './snippets/games-info-en';
import gamesInfoRo from './snippets/games-info-ro';
import licenseInfoEn from './snippets/license-info-en';
import licenseInfoRo from './snippets/license-info-ro';
import loginBannerEn from './snippets/login-banner-en';
import loginBannerRo from './snippets/login-banner-ro';
import passwordRecoveryBannerEn from './snippets/password-recovery-banner-en';
import passwordRecoveryBannerRo from './snippets/password-recovery-banner-ro';
import paymentsEn from './snippets/payments-en';
import paymentsRo from './snippets/payments-ro';
import privacyPolicyEn from './snippets/privacy-policy-en';
import privacyPolicyRo from './snippets/privacy-policy-ro';
import registerBannerEn from './snippets/reg-banner-en';
import registerBannerRo from './snippets/reg-banner-ro';
import registerSuccessEn from './snippets/register-success-en';
import registerSuccessRo from './snippets/register-success-ro';
import responsibleGamingEn from './snippets/responsible-gaming-en';
import responsibleGamingRo from './snippets/responsible-gaming-ro';
import termsConditionsEn from './snippets/terms-conditions-en';
import termsConditionsRo from './snippets/terms-conditions-ro';
import uploadFileInfoMessageEn from './snippets/upload-file-info-message-en';
import uploadFileInfoMessageRo from './snippets/upload-file-info-message-ro';
import welcomeBonusCasinoEn from './snippets/welcome-bonus-casino-en';
import welcomeBonusCasinoRo from './snippets/welcome-bonus-casino-ro';
import welcomeBonusLiveCasinoEn from './snippets/welcome-bonus-live-casino-en';
import welcomeBonusLiveCasinoRo from './snippets/welcome-bonus-live-casino-ro';
import welcomeBonusTopSlotsEn from './snippets/welcome-bonus-top-slots-en';
import welcomeBonusTopSlotsMobileEn from './snippets/welcome-bonus-top-slots-mobile-en';
import welcomeBonusTopSlotsMobileRo from './snippets/welcome-bonus-top-slots-mobile-ro';
import welcomeBonusTopSlotsRo from './snippets/welcome-bonus-top-slots-ro';

export const FALLBACK_SNIPPETS = {
  'license-info-2': {
    en: licenseInfoEn,
    ro: licenseInfoRo
  },
  'brand-info-2': {
    en: brandInfoEn,
    ro: brandInfoRo
  },
  'footer-rightNav-1': {
    en: footerRightNavEn,
    ro: footerRightNavRo
  },
  'terms-conditions': {
    en: termsConditionsEn,
    ro: termsConditionsRo
  },
  'about-us': {
    en: aboutUsEn,
    ro: aboutUsRo
  },
  'privacy-policy': {
    en: privacyPolicyEn,
    ro: privacyPolicyRo
  },
  'cookie-policy': {
    en: cookiePolicyEn,
    ro: cookiePolicyRo
  },
  'responsible-gaming': {
    en: responsibleGamingEn,
    ro: responsibleGamingRo
  },
  'cookie-privacy-notification': {
    en: cookieNotificationEn,
    ro: cookieNotificationRo
  },
  'games-info': {
    en: gamesInfoEn,
    ro: gamesInfoRo
  },
  'welcome-bonus-casino': {
    ro: welcomeBonusCasinoRo,
    en: welcomeBonusCasinoEn
  },
  'welcome-bonus-live-casino': {
    ro: welcomeBonusLiveCasinoRo,
    en: welcomeBonusLiveCasinoEn
  },
  'welcome-bonus-top-slots': {
    ro: welcomeBonusTopSlotsRo,
    en: welcomeBonusTopSlotsEn
  },
  'welcome-bonus-top-slots-mobile': {
    en: welcomeBonusTopSlotsMobileEn,
    ro: welcomeBonusTopSlotsMobileRo
  },
  'deposit-neteller': {
    en: depositNetellerEn,
    ro: depositNetellerRo
  },
  'deposit-skrill': {
    en: depositSkrillEn,
    ro: depositSkrillRo
  },
  payments: {
    en: paymentsEn,
    ro: paymentsRo
  },
  'info-message-snippet': {
    en: uploadFileInfoMessageEn,
    ro: uploadFileInfoMessageRo
  },
  'footer-socials-1': {
    en: footerSocialsEn,
    ro: footerSocialsRo
  },
  'footer-help-1': {
    ro: footerHelpRo,
    en: footerHelpEn
  },
  'register-banner': {
    en: registerBannerEn,
    ro: registerBannerRo
  },
  'login-banner': {
    en: loginBannerEn,
    ro: loginBannerRo
  },
  'register-success': {
    en: registerSuccessEn,
    ro: registerSuccessRo
  },
  'password-recovery-banner': {
    en: passwordRecoveryBannerEn,
    ro: passwordRecoveryBannerRo
  },
  'cookie-declaration': {
    ro: cookieDeclarationRo,
    en: cookieDeclarationEn
  }
};
